export const normalizeEmailForAllowlist = (email?: string | null) =>
  typeof email === 'string' ? email.trim().toLowerCase() : '';

export const isEmailAllowlisted = ({
  email,
  allowedEmails,
}: {
  email?: string | null;
  allowedEmails?: unknown;
}) => {
  if (!Array.isArray(allowedEmails)) {
    return false;
  }

  const normalizedEmail = normalizeEmailForAllowlist(email);

  if (!normalizedEmail) {
    return false;
  }

  return allowedEmails.some(
    allowedEmail =>
      normalizeEmailForAllowlist(
        typeof allowedEmail === 'string' ? allowedEmail : null,
      ) === normalizedEmail,
  );
};
